import { AdditionalInfoGallery } from './AdditionalInfoGallery/AdditionalInfoGallery';

export const AdditionalInfoSection: React.FC = () => {
	return <AdditionalInfoGallery />;
};
